module.exports = __webpack_public_path__ + "assets/images/project/head/Tilak_Mehta.jpg?v=bf7cd144";